import { create } from 'zustand';
import { persist } from 'zustand/middleware';


interface AppState {
    isDrawerMenuOpen: boolean;
    changeDrawerMenuState: (state: boolean) => void;
    facebookEventsHash: { [key: string]: boolean };
    setFacebookEventsHash: (hash: string) => void;
}

export const useAppState = create<AppState>()(
    persist(
        (set, get) => ({
            isDrawerMenuOpen: false,
            changeDrawerMenuState: (state) => set({
                isDrawerMenuOpen: state,
            }),
            facebookEventsHash: {},
            setFacebookEventsHash: (hash) => set((state) => ({
              facebookEventsHash: {
                   ...state.facebookEventsHash,
                   [hash]: true
               }
            }))
        }),
        {
            name: 'app-storage',
            version: 1,
            // Only persist choices, not the current step
            partialize: (state) => ({
                isDrawerMenuOpen: state.isDrawerMenuOpen
            }),
        }
    )
);
